import { PropsWithChildren, useState, FC } from 'react'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import { ExceptionFailureModal } from '../ExceptionFailureModal'

import { PLACEMENT } from './constants'
import { ExceptionFailuresDrawerTitleType } from './types'
import styles from './styles.css'

const ExceptionsDrawerTitle: FC<
    PropsWithChildren<ExceptionFailuresDrawerTitleType>
> = ({ jobData, refetchExceptionsVariables }) => {
    const [showExceptionCreationModal, setShowExceptionCreationModal] =
        useState(false)

    return (
        <>
            <Box
                justifyContent="between"
                alignItems="center"
                className={styles.drawerTitleContainer}
            >
                <Text className={styles.drawerTitleText}>
                    Exceptions - {jobData.name}, {jobData.salesOrderName}
                </Text>
                <Button
                    type="primary"
                    onClick={(evt: Event) => {
                        evt.stopPropagation()
                        setShowExceptionCreationModal(true)
                    }}
                    data-test-target={`create-failure-exception-${PLACEMENT}`}
                    name="create-new-failure-exception"
                    placement={PLACEMENT}
                >
                    <Text className={styles.createExceptionButtonText}>
                        Create new exception
                    </Text>
                </Button>
            </Box>
            {showExceptionCreationModal && (
                <ExceptionFailureModal
                    jobData={jobData}
                    handleCancel={() => {
                        setShowExceptionCreationModal(false)
                    }}
                    refetchExceptionsVariables={refetchExceptionsVariables}
                />
            )}
        </>
    )
}

export default ExceptionsDrawerTitle
